import "./pages.css";

const values = [
  { title: "RAW", desc: "We embrace imperfection as a design philosophy." },
  { title: "MINIMAL", desc: "Less noise. More meaning. Always intentional." },
  { title: "AUTHENTIC", desc: "Built on the streets. Made for the real." },
];

const socials = [
  {
    label: "INSTAGRAM",
    handle: "@nastyauthentic",
    url: "https://www.instagram.com/nastyauthentic/",
  },
  {
    label: "LINKEDIN",
    handle: "Nasty Authentic",
    url: "https://www.linkedin.com/company/nasty-authentic/?",
  },
  {
    label: "FACEBOOK",
    handle: "Nasty Authentic",
    url: "https://www.facebook.com/profile.php?id=61588794523685",
  },
];

function AboutPage() {
  return (
    <div className="page">
      <p className="section-title">THE BRAND</p>
      <h1 className="bigTitle">NASTY AUTHENTIC</h1>

      <div className="about__top">
        <div className="about__content">
          <h2 className="about__heading">OUR STORY</h2>
          <p className="about__text">
            NastyAuthentic was born from a simple idea: streetwear doesn't need
            to be loud to make a statement. We believe in the power of
            minimalism, the beauty of raw authenticity, and the strength of
            staying true to yourself.
          </p>
          <p className="about__text">
            Founded in the heart of the urban jungle, we've built our brand on
            the streets, for the streets. Every design, every stitch, every
            detail is crafted with precision and passion.
          </p>
        </div>
        <video
          autoPlay
          muted
          loop
          playsInline
          preload="none"
          style={{
            width: "100%",
            height: "520px",
            objectFit: "cover",
            border: "1px solid #1a1a1a",
            borderRadius: "8px",
          }}
          aria-label="Promotional demo showing product."
        >
          <source
            src="https://res.cloudinary.com/dqj2x8qjx/video/upload/v1777661719/WhatsApp_Video_2026-05-02_at_00.04.48_ftkvva.mp4"
            type="video/mp4"
          />
        </video>
      </div>

      {/* Values Cards */}
      <div className="about__grid">
        {values.map((item) => (
          <div key={item.title} className="about__card">
            <h3 className="about__card-title">{item.title}</h3>
            <p className="about__card-text">{item.desc}</p>
          </div>
        ))}
      </div>

      {/* Social Links */}
      <div className="about__socials">
        <p className="section-title" style={{ marginBottom: 16 }}>
          FOLLOW THE BRAND
        </p>
        {socials.map((s) => (
          <a
            key={s.label}
            href={s.url}
            target="_blank"
            rel="noopener noreferrer"
            className="about__social-row"
          >
            <span className="about__social-label">{s.label}</span>
            <span className="about__social-handle">{s.handle}</span>
            <span className="about__social-arrow">→</span>
          </a>
        ))}
      </div>
    </div>
  );
}

export default AboutPage;
